import { encryptBytes, decryptBytes } from './crypto';
// Login siempre usa la URL fija de usuarios_conversaciones con code
export const LOGIN_URL = 'https://headspringchatbot.azurewebsites.net/api/usuarios_conversaciones?code=AtlU_yuKGwLNPV7igGaqgtHylvaaqh6klALNXL_ZJJKvAzFuzYjyyw==';

/**
 * Realiza login enviando token cifrado y retorna datos de usuario descifrados.
 * @param correo correo del usuario
 * @param password contraseña del usuario
 */
export async function login(correo: string, password: string) {
  const key = process.env.REACT_APP_FERNET_KEY;
  if (!key) {
    throw new Error('Falta definir REACT_APP_FERNET_KEY en .env');
  }
  const payload = JSON.stringify({ correo, password });
  const token = encryptBytes(payload, key);

  // Usar LOGIN_URL para verificar credenciales
  const res = await fetch(LOGIN_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, accion: 'login' }),
  });

  // Siempre leemos el texto crudo
  const text = await res.text();
  if (!res.ok) {
    // Si no es 200, lanzamos error con la respuesta del servidor
    throw new Error(text);
  }

  // Desencripto la respuesta
  let decrypted: string;
  try {
    decrypted = decryptBytes(text, key);
  } catch (err: any) {
    throw new Error('Error desencriptando respuesta: ' + err.message);
  }
  const parsed = JSON.parse(decrypted);
  return { ...parsed, token };
} 